import { Navigation } from "@/components/NavigationContext"
import Head from "next/head"
import Link from "next/link"
import { useContext, useEffect } from "react"

const Gallery = ({ content, navigation }) => {
    const { setNavigationItems } = useContext(Navigation)

    useEffect(() => {
        if (navigation) {
            setNavigationItems(navigation)
        }
    }, [navigation])

    return (
        <>
            <Head>
                <title>{content.title || ''} | Studio Rinsma</title>
                <meta name="description" content={`See my photography of ${content.title}`} />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <div className="page-gallery-item">
                <header>
                    <div className="global-wrapper">
                        <div className="header-inner">
                            <h1>
                                <span className="heading-js-wrapper">
                                    <span style={{ animationDelay: '.2s' }}>{content.title}</span>
                                </span>
                            </h1>
                        </div>
                    </div>
                </header>

                <section className="categories-wrapper">
                    <div className="global-wrapper">
                        <div className="categories-inner">
                            {content.photographyPhotos.map((image, index) => {
                                if (image.orientation === 'horizontal') {
                                    return (
                                        <img key={index} src={image.horizontalAssets.url} alt={image.horizontalAssets.title} className="horizontal" />
                                    )
                                } else {
                                    return image.verticalAssets.map((imageVertical, index) => (
                                        <img key={index} src={imageVertical.url} alt={imageVertical.title} />
                                    ))
                                }
                            })}
                        </div>
                    </div>
                </section>

                <section className="cta-wrapper">
                    <div className="global-wrapper">
                        <Link href={`/${content.cta.link}`} className="cta-inner">
                            <div className="cta-content">
                                <span className="cta-title">{content.cta.title}</span>
                                <span className="cta-subtext">{content.cta.subtext}</span>
                            </div>

                            <div className="cta-link-wrapper">
                                <i className="fas fa-arrow-right-long" />
                            </div>
                        </Link>
                    </div>
                </section>
            </div>
        </>
    )
}

export default Gallery

export async function getServerSideProps({ params }) {
    const res = await fetch(`${process.env.API_URL}/api/gallery/${params.slug}.json`)
    const content = await res.json()

    const navigationRes = await fetch(`${process.env.API_URL}/api/globals.json`)
    const navigation = await navigationRes.json()

    return {
        props: {
            content,
            navigation,
        }
    }
}